import Screen       from './screen'
import vesselMixin  from './mixin'
import applyMethod  from './methods/apply'
import coerceMethod from './methods/coerce'
import extendMethod from './methods/extend'
import renderMethod from './methods/render'

import { hasProp } from 'vessel/utils'

const Plugin = {
  install(Vue) {
    const merge = Vue.config.optionMergeStrategies.methods

    Vue.config.optionMergeStrategies.vessel = function (toVal, fromVal) {
      if (!toVal) return fromVal
      if (!fromVal) return toVal

      const options = Object.assign({}, toVal)

      Object.keys(fromVal).forEach(group => {
        let value = fromVal[group]

        if (hasProp(group, toVal))
          value = Object.assign({}, merge(toVal[group], value))

        options[group] = value
      })

      return options
    }

    Vue.use(Screen)

    Vue.prototype.$vessel = {
      apply: applyMethod,
      coerce: coerceMethod,
      extend: extendMethod,
      render: renderMethod
    }

    Vue.mixin(vesselMixin)
  }
}

export default Plugin
